// import React, { Component,useState } from 'react';
// import TableHeader from './TableHeader';
// import TableBody from './TableBody';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/free-solid-svg-icons';
// import _ from 'lodash';
// import './table.css';

// const Table = (props) => {
//     const [query,setQuery]=useState('');
//     const { columns, data, viewSelected, sortColumn, onSort,totalTitle, id,height,total } = props;
//     const [isInputFocused, setIsInputFocused] = useState(false);


//     const handleInputFocus = () => {
//       setIsInputFocused(true);
//     };
  
//     const handleInputBlur = () => {
//       setIsInputFocused(false);
//     };
  
//     const outerDivStyle = {
//       boxShadow: isInputFocused ? '0px 0px 5px 3px #bcc6e3' : '0px 0px 5px 2px rgba(0, 0, 0, 0.1)',

//     };
//     // consol(columns);
//     // consol(data)
//     const handleOnChange=(e)=>{
//       setQuery(e.currentTarget.value);
//     }

//     const getData=(data)=>{
//         let cloneData=[...data];
//         if(query==""){
           
//         }else{
//             cloneData=searchArrayOfObjects(cloneData,query)
//             }
//         return cloneData;
//     }

//     const searchArrayOfObjects=(arr,search)=>{
//      let arr1=[]
//      for(let i=0;i<arr.length;i++){
//         let keys=Object.keys(arr[i])
//         for(let k=0;k<keys.length;k++){
//             if(_.includes(arr[i][keys[k]],search)){
//                 arr1.push(arr[i]);
//                 break;
//             }
//         }
//      }
//      return arr1;
//     }
//     return (
//         <div className='py-2 table-screen' >
//           <div className='desktop-only'>
//            <div className="  input-group mb-2 mx-2 w-auto mx-2 px-2 d-flex align-items-center bg-white rounded-pill " style={outerDivStyle}>
//       <span
//         className="d-flex align-items-center p-1 my-1 mr-1"
//         style={{
//           height: '32px',
//           width: '32px',
//           border: '3px solid #bcc6e3',
//           borderRadius: '50%',
//           boxShadow: '0px 0px 2px 1px rgba(0, 0, 0, 0.3)',
//         }}
//       >
//         <FontAwesomeIcon color="#bcc6e3" icon={faSearch} />
//       </span>

//       <input
//         type="text"
//         onChange={(e)=>handleOnChange(e)}
//         onFocus={handleInputFocus}
//         onBlur={handleInputBlur}
//         className="d-flex align-items-center form-control-sm mx-2 "
//         style={{ background: 'white' ,borderLeft:'1px solid #e8e8e8',borderTop:'0px',borderBottom:'0px',borderRight:'0px'}}
//         placeholder="Search..."
//         aria-label="Search"
//         aria-describedby="basic-addon1"
//       />
//     </div>
//     </div>
//     <div className="mobile-only">
//     <div className="  input-group mb-2 mx-2 w-auto mx-2 px-2 d-flex align-items-center bg-white rounded-pill " style={outerDivStyle}>
//       <span
//         className="d-flex align-items-center p-1 my-1 mr-1"
//         style={{
//           height: '16px',
//           width: '16px',
//           // border: '3px solid #bcc6e3',
//           borderRadius: '50%',
//           // boxShadow: '0px 0px 2px 1px rgba(0, 0, 0, 0.3)',
//         }}
//       >
//         <FontAwesomeIcon color="#bcc6e3" icon={faSearch} />
//       </span>

//       <input
//         type="text"
//         onChange={(e)=>handleOnChange(e)}
//         onFocus={handleInputFocus}
//         onBlur={handleInputBlur}
//         className="d-flex align-items-center form-control-sm mx-2 "
//         style={{ background: 'white' ,borderLeft:'1px solid #e8e8e8',borderTop:'0px',borderBottom:'0px',borderRight:'0px'}}
//         placeholder="Search..."
//         aria-label="Search"
//         aria-describedby="basic-addon1"
//       />
//     </div>
//     </div>
//     <div
//   // className="table-responsive"
//   style={{ minHeight: height === 'auto' ? '' : '600px' }}
// >


// <table
//   id={id}
//   className={props.grid
//     ? "table table-bordered table-striped small table-sm table-hover  " 
//     : "table table-bordered table-striped small table-sm table-hover  "}
//   style={{ fontSize: 14, padding: 0 }}
// >
//   <TableHeader id={id} columns={columns} sortColumn={sortColumn} onSort={onSort} />
//   <TableBody totalTitle={totalTitle} total={total} data={getData(data)} columns={columns} />
// </table>

//     </div>
//             </div>);
// }

// export default Table;

import React, { useState } from 'react';
import { Input, Table as AntdTable } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import _ from 'lodash';
import './table.css';

const Table = (props) => {
  const { columns, data, sortColumn, onSort, total, totalTitle, id, height, pagination, highlightFinalOp, hideSearch } = props;
  const [query, setQuery] = useState('');

  const handleSearchChange = (e) => {
    setQuery(e.target.value);
  };

  const searchArrayOfObjects = (arr, search) => {
    return arr.filter(item =>
      Object.keys(item).some(key =>
        _.includes(String(item[key]).toLowerCase(), search.toLowerCase())
      )
    );
  };

  const filteredData = query ? searchArrayOfObjects([...data], query) : data;

  const calculateTotal = (data, column) => {
    const parseNumeric = (val) => isNaN(parseFloat(val)) ? 0 : parseFloat(val);
    let total = 0;

    if (column.PartOfFaimly) {
      // Rows sharing one machine window (a family mould, or several tools running together)
      // count once. A per-tool column (PartOfFaimly: 'perTool') counts once per tool instead,
      // since every tool of a tool group ran the machine's full cycles.
      const grouped = _.groupBy(
        data.filter(item => item.PartOfFaimly),
        item => column.PartOfFaimly === 'perTool'
          ? `${item.Equipment}-${item.From}-${item.Till}-${item.Tool || ''}`
          : `${item.Equipment}-${item.From}-${item.Till}`
      );

      Object.values(grouped).forEach(group => {
        total += parseNumeric(_.get(group[0], column.path));
      });

      data.filter(item => !item.PartOfFaimly).forEach(item => {
        total += parseNumeric(_.get(item, column.path));
      });
    } else {
      data.forEach(item => {
        total += parseNumeric(_.get(item, column.path));
      });
    }

    return total;
  };

  const getTotalRow = () => {
    if (!total) return [];

    const totals = columns.reduce((acc, col) => {
      if (col.total) {
        acc[col.path] = calculateTotal(data, col);
      }
      return acc;
    }, {});

    return [
      {
        _id: 'total',
        ...totals,
        isTotalRow: true,
        totalLabel: `Total${totalTitle ? `${totalTitle}` : ''}`,
      },
    ];
  };

  const combinedData = [...filteredData, ...getTotalRow()];

  const enhancedColumns = columns.map((col, idx) => ({
    title: col.label,
    dataIndex: col.path,
    key: col.key || col.path || col.label,
    sorter: col.path ? (a, b) => {
      if (a._id === 'total' || b._id === 'total') return 0;
      const aVal = _.get(a, col.path);
      const bVal = _.get(b, col.path);
      const aNum = parseFloat(aVal);
      const bNum = parseFloat(bVal);
      // IDs like 098D3D6AE58E7117 start with digits, so parseFloat would read them
      // all as 98 - values containing letters get a natural text sort instead.
      const hasLetters = (v) => /[a-z]/i.test(String(v ?? ''));
      if (!hasLetters(aVal) && !hasLetters(bVal) && !isNaN(aNum) && !isNaN(bNum)) return aNum - bNum;
      return String(aVal ?? '').localeCompare(String(bVal ?? ''), undefined, { numeric: true });
    } : false,
    fixed: col.fixed || undefined,
    width: col.width || (col.fixed ? 140 : Math.max(
      80,
      String(col.label || '').split(/\s+/).reduce((m, w) => Math.max(m, w.length), 0) * 8.5 + 44
    )),
    ellipsis: col.ellipsis || false,
    total: col.total || false,
    PartOfFaimly: col.PartOfFaimly || false,
   render: (value, record, index) => {
  if (record._id === 'total') {
    const val = record[col.path];
    const isFirstColumn = idx === 0;

    if (col.total && val !== undefined) {
      return (
        <span style={{ fontWeight: 'bold', background: col.PartOfFaimly ? '#f5f5dc' : 'lightgrey' }}>
          {val?.toFixed(1)}
        </span>
      );
    } else if (isFirstColumn) {
      return <strong>{record.totalLabel}</strong>;
    } else {
      return '';
    }
  }

  return col.content ? col.content(record, index) : _.get(record, col.path);
}

  }));

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      onSort && onSort({
        path: sorter.field,
        order: sorter.order === 'ascend' ? 'asc' : 'desc',
      });
    }
  };

  return (
    <div className='table-screen'>
      {!hideSearch && (
      <div className="mb-1 px-2">
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search..."
          onChange={handleSearchChange}
          allowClear
          style={{ maxWidth: '100%' }}
        />
      </div>
      )}

      <AntdTable
        id={id}
        rowKey={record => record._id || Math.random()}
        columns={enhancedColumns}
        dataSource={combinedData}
        pagination={pagination
          ? {
              defaultPageSize: (pagination && pagination.pageSize) || 25,
              pageSizeOptions: ['25', '50', '100', '200', '500'],
              showSizeChanger: true,
              showTotal: (totalCount, range) => `${range[0]}-${range[1]} of ${totalCount} records`,
            }
          : false}
        onChange={handleTableChange}
        bordered
        size="small"
        rowClassName={(record) => {
          const classes = [];
          if (record.PartOfFaimly) classes.push('family-tool-row');
          if (highlightFinalOp && record.IsFinalOp) classes.push('final-op-row');
          return classes.join(' ');
        }}
        scroll={{
          x: 'max-content',
          y: height === 'auto' ? undefined : (height || '65vh'),
        }}
        style={{ minHeight: height === 'auto' ? 'auto' : 'auto' }}
      />
     { totalTitle ? <div className="">* Highlighted rows are <strong>Family Tool Jobs</strong> — only one cycle is considered per family group in the total.</div>:''}
    </div>
  );
};

export default Table;
